import styled from "styled-components";

const Style = styled.div`
  display: flex;
`;

export default Style;
